import React, { useContext, useState, useCallback, useRef } from 'react'
import { statusLabelMaper } from '../../service/AppContext'
import { appContext } from '../../service/AppContext';
import { toast } from 'react-toastify';
import Input from '../Input/Input';
import { debounce } from 'lodash';
import ReactPlayer from 'react-player'



export default function VideoTableRow({ number, id, title, description, url, site_title, upload_date, post_id, status, handleUpdate, handleRemove }) {

  const [openEdit, setOpenEdit] = useState(false);
  const [preview, setPreview] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false) 
  const [copyedLink, setCopyedLink] = useState(false)
  const [videoTitle, setVideoTitle] = useState(title)
  const [videoSiteTitle, setVideoSiteTitle] = useState(site_title)
  const [videoDesciption, setVideoDesciption] = useState(description ? description : '')
  const { breslevRequest } = useContext(appContext);

  const downloadAnchorRef = useRef(null);
  const [downloadLinkData, setDownloadLinkData] = useState({ href: '', filename: '' });

  const handleChangeTitle = (event) => {
    handleUpdateByElementName(event);
    setVideoTitle(event.target.value);
  }

  const handleChangeSiteTitle = (event) => {
    handleUpdateByElementName(event);
    setVideoSiteTitle(event.target.value);
  }

  const handleChangeDescription = (event) => {
    handleUpdateByElementName(event);
    setVideoDesciption(event.target.value);
  }

  const handleCopyLink = () => {
    setCopyedLink(true);
    navigator.clipboard.writeText(url);
    setTimeout(() => { setCopyedLink(false) }, 1000)

  }

  const handleUpdateByElementName = useCallback(debounce(async (event) => {
    let keyName = event.target.name;
    let updateObj = { id: id, [keyName]: event.target.value }
    let response = await breslevRequest({ method: 'put', route: '/video/update', body: updateObj })
    if (response?.status === 204) {
      if (keyName === 'title')
        toast('שם הסרטון עודכן');
      if (keyName === 'site_title')
        toast('כותרת הסרטון עבור האתר עודכנה');
      if (keyName === 'description')
        toast('תיאור הסרטון עודכן');
      handleUpdate(updateObj);
    }
    else
      toast('שגיאה בעדכון פרטי סרטון');
  }, 1000, { leading: false, trailing: true })
    , [id])

  const handleRemoveElement = (async () => {
    setIsLoading(true)
    let response = await breslevRequest({ method: 'delete', route: '/video/delete/' + id })
    if (response?.status === 204) {
      toast('הסרטון הוסר בהצלחה');
      handleRemove();
    }
    else {
      toast('מחיקת הסרטון נכשלה , נסה שנית עוד מספר דקות');
    }
    setIsLoading(false)
  })

  const handleDownloadElement = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    
    try {
      const response = await breslevRequest({ 
        method: 'get', 
        route: `/video/download/${id}`,
        responseType: 'blob', 
        headers: {
          'Accept': 'application/octet-stream'
        }
      });

      if (response) {
        const rawBlob = response.data ? response.data : response;
        const fileBlob = rawBlob instanceof Blob ? rawBlob : new Blob([rawBlob]);

        if (fileBlob.type && fileBlob.type.includes('text')) {
          const errorText = await fileBlob.text();
          toast(`שגיאה בהורדה: ${errorText || 'הקובץ לא נמצא בשרת'}`);
          return;
        }

        let finalFileName = `${videoTitle?.trim() || 'video'}.mp4`;
        
        if (response.headers && response.headers['content-disposition']) {
          const disposition = response.headers['content-disposition'];
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) { 
            finalFileName = matches[1].replace(/['"]/g, '');
          }
        }

        const downloadUrl = window.URL.createObjectURL(fileBlob);
        
        setDownloadLinkData({ href: downloadUrl, filename: finalFileName });

        setTimeout(() => {
          if (downloadAnchorRef.current) {
            downloadAnchorRef.current.click();
            window.URL.revokeObjectURL(downloadUrl);
            toast('ההורדה החלה בהצלחה');
          }
        }, 50);

      } else {
        toast('שגיאה בהורדת הקובץ מהשרת');
      }
    } catch (error) {
      console.error('Download error:', error);
      toast('הקובץ לא נמצא בשרת או שהורדתו נכשלה');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <tr>
        <td>
          {number}
        </td>
        {(openEdit) ?
          <>
            <td>
              <Input name='title' value={videoTitle} onChange={handleChangeTitle} disabled={isLoading || isDownloading} />
            </td>
            <td>
              <Input name='site_title' value={videoSiteTitle} onChange={handleChangeSiteTitle} disabled={isLoading || isDownloading} />
            </td>
            <td>
              <textarea name='description' rows={3} placeholder='תיאור הסרטון' onChange={handleChangeDescription} value={videoDesciption} disabled={isLoading || isDownloading} />
            </td>
          </>
          :
          <>
            <td>
              {title}
            </td>
            <td>
              {site_title}
            </td>
            <td>
              {description}
            </td>

          </>
        }
        <td>
          {upload_date}
        </td>
        
        <td>
          <a 
            ref={downloadAnchorRef} 
            href={downloadLinkData.href} 
            download={downloadLinkData.filename} 
            style={{ display: 'none' }} 
          />
          <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            flexWrap: 'wrap', 
            gap: '12px', 
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}>
            <span className="copy-text-action" onClick={handleCopyLink} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
              <img src="./icons/copy.svg" alt="copy url to clipboard" style={{ marginLeft: '5px' }} />העתק
              {
                (copyedLink) &&
                <span className="copy-text-notification"><span className="block-snippet">הועתק!</span></span>
              }
            </span>

            <span 
              className={`copy-text-action ${isDownloading ? 'disabled' : ''}`} 
              onClick={handleDownloadElement}
              style={{ 
                cursor: isDownloading ? 'not-allowed' : 'pointer', 
                opacity: isDownloading ? 0.6 : 1,
                whiteSpace: 'nowrap',
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              {isDownloading ? (
  <img className='spinner' src="./circle-notch-solid.svg" alt="download spinner" style={{ marginLeft: '5px', width: '14px', height: '14px' }} />
) : (
  <img 
  src="./icons/download.svg" 
  alt="" 
  style={{ marginLeft: '6px', width: '16px', height: '16px', verticalAlign: 'middle' }} 
/>
)}
              
              {isDownloading ? 'מוריד...' : 'הורדה'}
            </span>
          </div>
        </td>
        <td>
          {statusLabelMaper[status]}
        </td>
        <td>
          {post_id}
        </td>
        <td>
          <div className='edit-col' style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
            <button className='button' onClick={() => setPreview(prev => !prev)} disabled={isLoading || isDownloading}>{(preview) ? 'הסתר' : 'צפייה'} </button>
            <button className='button' onClick={() => setOpenEdit(prev => !prev)} disabled={isLoading || isDownloading}>{(openEdit) ? 'סגירה' : 'ערוך'} </button>
            <button className='button button-error button-spinner' onClick={handleRemoveElement} disabled={isLoading || isDownloading}>מחיקה
              {(isLoading) && <img className='spinner' src="./circle-notch-solid.svg" alt="button spinner" />}
            </button>
          </div>
        </td>
      </tr>
      <tr className='preview'>
        {(preview) &&
          <td colSpan='100%' >
            <ReactPlayer url={url} controls={true} playing={true} style={{ margin: '20px auto' }} width={'100%'}  />
          </td>}
      </tr>
    </>

  )
}
